function storageAvailable(type) {
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch(e) {
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
}

function highvizSet() {
    if( storageAvailable( 'localStorage' )) {
        if( localStorage.getItem( 'unit-view-high-contrast' )) {
            return true;
        } else {
            return false;
        }
    } else if( storageAvailable( 'sessionStorage' )) {
        if( sessionStorage.getItem( 'unit-view-high-contrast' )) {
            return true;
        } else {
            return false;
        }
    }
    else {
        return false;
    }
}

function highvizSetStorage() {
    if( storageAvailable( 'localStorage' )) {
        if( !localStorage.getItem( 'unit-view-high-contrast' )) {
            console.log('setting highviz')
            localStorage.setItem( 'unit-view-high-contrast', true );
        }
    } else if( storageAvailable( 'sessionStorage' )) {
        if( !sessionStorage.getItem( 'unit-view-high-contrast' )) {
            sessionStorage.setItem( 'unit-view-high-contrast', true );
        }
    }
}

function highvizToggleStorage() {
    if( storageAvailable( 'localStorage' )) {
        if( !localStorage.getItem( 'unit-view-high-contrast' )) {
            console.log('setting highviz')
            localStorage.setItem( 'unit-view-high-contrast', true );
        } else {
            console.log('removing highviz')
            localStorage.removeItem( 'unit-view-high-contrast' );
        }
    } else if( storageAvailable( 'sessionStorage' )) {
        if( !sessionStorage.getItem( 'unit-view-high-contrast' )) {
            sessionStorage.setItem( 'unit-view-high-contrast', true );
        } else {
            sessionStorage.removeItem( 'unit-view-high-contrast' );
        }
    }
    else {
    }
}


/**
 * HERE'S WHERE IT ALL HAPPENS
 * 
 * The wrapper must be findable by ID (no tags)
 * 
 * @param {*} toggle_button 
 * @param {*} wrapper_element 
 * @param {*} class_toggle 
 * @returns 
 */

export default function viewSwitcher ( toggle_button, wrapper_element, class_toggle ) {
    // Get our toggling button and wrapper
    const toggler = document.getElementById( toggle_button );
    const wrapper = document.getElementById( wrapper_element );

    // Check they exist and forget it if they don't
    if ( !document.body.contains(toggler) || !document.body.contains(wrapper) ) {
        return;
    }

    let highVizStored = highvizSet();
    let highVizClass = wrapper.classList.contains(class_toggle);

    if( highVizStored && ! highVizClass ) { // if highviz cookie switched OFF but class ON
        wrapper.classList.toggle( class_toggle );
    }
    toggler.addEventListener( 'click', (e) => {
        e.preventDefault();
        wrapper.classList.toggle( class_toggle );
        highvizToggleStorage();
    })
}